/**
 * CMSPage - Dynamic CMS Page Component
 *
 * This component renders CMS-based pages using the PageBuilder.
 * It's currently active for all /p/:pageId routes EXCEPT /p/faq which has a custom implementation.
 *
 * IMPORTANT: The /p/faq route now uses a custom FAQPage component (see src/containers/FAQPage/FAQPage.js)
 * This was done to provide a custom-designed FAQ page with accordion functionality and black background.
 *
 * To revert /p/faq back to using this CMS-based approach:
 * 1. Go to src/routing/routeConfiguration.js
 * 2. Remove or comment out the specific /p/faq route
 * 3. The /p/:pageId route below will then handle /p/faq again
 *
 * Last modified: Creating custom FAQ page with accordion design
 */

import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  console.log('Rendering CMSPage', JSON.stringify({ pageId, pageAssetsData, inProgress, error }));
  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(withRouter, connect(mapStateToProps))(CMSPageComponent);

export default CMSPage;
